import axios from 'axios'

import {
  authorizationHeaderInterceptor,
  forbiddenOrTokenExpiredInterceptor,
  serverAvailabilityInterceptor,
  adminTransformInterceptor
} from './configureInterceptors'

export const ApiName = {
  ADMINS: 'admins',
  FINANCIALINSTITUTIONS: 'financialInstitutions',
  LOGIN: 'login',
  CONFIGS: 'configs',
  PTAXES: 'ptaxes',
  BANKS: 'banks',
  OPERATIONS: 'operations',
  DOCUSIGN: 'docusign',
  ARCHIVES: 'archives',
  TPAY: 'tpay',
  MARKETSTATUS: 'market_statuses'
}

class ApiClient {
  constructor() {
    const { VITE_APP_URL } = import.meta.env

    this.apiClient = axios.create({
      baseURL: `${VITE_APP_URL}`
    })

    serverAvailabilityInterceptor(this.apiClient.interceptors.request)
    authorizationHeaderInterceptor(this.apiClient.interceptors.request)
    forbiddenOrTokenExpiredInterceptor(this.apiClient.interceptors.response)

    adminTransformInterceptor(this.apiClient.interceptors.response)
  }

  get(apiName, resource, config, requestConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.get(endpoint, { ...requestConfig, params: config })
  }

  post(apiName, resource, data, additionalHeaders = {}, requestConfig = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.post(endpoint, data, {
      ...requestConfig,
      headers: {
        ...additionalHeaders
      }
    })
  }

  patch(apiName, resource, data, additionalHeaders = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.patch(endpoint, data, {
      headers: { ...additionalHeaders }
    })
  }

  put(apiName, resource, data, additionalHeaders = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.put(endpoint, data, {
      headers: { ...additionalHeaders }
    })
  }

  delete(apiName, resource, id) {
    const endpoint = resource ? `/${apiName}/${resource}/${id}` : `/${apiName}/${id}`
    return this.apiClient.delete(endpoint)
  }
}

export const apiClient = new ApiClient()
